import React, { useState, useEffect } from 'react';
import TodoForm from './components/TodoForm';
import TodoList from './components/TodoList';
import "./App.css"

const App = () => {
  const [todos, setTodos] = useState([]);

  // Fetch todos from backend API on component mount
  useEffect(() => {
    const fetchTodos = async () => {
      const response = await fetch('https://sahitvasu.info/api/todo/v1/todos/');
      const data = await response.json();
      setTodos(data);
    };
    fetchTodos();
  }, []);

  // Add a new todo to the list
  const addTodo = async (newTodo) => {
    const response = await fetch('https://sahitvasu.info/api/todo/v1/todos/add/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newTodo),
    });
    const data = await response.json();
    setTodos([...todos, data]);
  };

  // Delete a todo from the list
  const deleteTodo = async (id) => {
    await fetch(`https://sahitvasu.info/api/todo/v1/todos/delete/${id}/`, {
      method: 'DELETE',
    });
    setTodos(todos.filter((todo) => todo.id !== id));
  };

  // Toggle the 'completed' status of a todo
  const toggleComplete = async (id) => {
    const todo = todos.find((todo) => todo.id === id);
    const updatedTodo = { ...todo, completed: !todo.completed };

    const response = await fetch(`https://sahitvasu.info/api/todo/v1/todos/update/${id}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedTodo),
    });
    const data = await response.json();
    setTodos(todos.map((todo) => (todo.id === id ? data : todo)));
  };

  return (
    <div>
      <h1>Todo App</h1>
      <TodoForm addTodo={addTodo} />
      <TodoList
        todos={todos}
        deleteTodo={deleteTodo}
        toggleComplete={toggleComplete}
      />
    </div>
  );
};

export default App;
